import { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { AiOutlineClose, AiOutlineCheck, AiFillClockCircle } from "react-icons/ai";
import { useSelector, useDispatch } from 'react-redux';
import host from "../../host";
import axiosInstance from '../../utils/axiosInstanse';
import { clearNotification } from '../../reduser/notificationSlice';
import './style.css';
import { showNotification } from '../../utils/notificationUtils';

export default function Cards(item) {
  const { note } = item;
  const [currentNote, setCurrentNote] = useState(note);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const actionsRef = useRef(null);
  const notification = useSelector(state => state.notification);
  const dispatch = useDispatch();

  // Закрытие дропдауна при клике вне
  useEffect(() => {
    if (!dropdownOpen) return;
    const handleClick = (e) => {
      if (actionsRef.current && !actionsRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [dropdownOpen]);

  const getCardMod = () => {
    if (currentNote.approved === false) return 'sub-card-arch--inactive';
    if (currentNote.approved) return 'sub-card-arch--active';
    return 'sub-card-arch--pending';
  };

  const format_data = data => {
    const date = new Date(data);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  useEffect(() => {
    if (notification.show) {
      const now = Date.now();
      const elapsedTime = now - notification.startTime;
      const remainingTime = 4000 - elapsedTime;
      if (remainingTime > 0) {
        const timer = setTimeout(() => {
          dispatch(clearNotification());
        }, remainingTime);
        return () => clearTimeout(timer);
      } else {
        dispatch(clearNotification());
      }
    }
  }, [notification, dispatch]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axiosInstance.post(`${host}api/delete_substitution/`, currentNote);
      if (response.status === 200) {
        setCurrentNote(response.data);
        showNotification(dispatch, 'Успешно!', 'success');
      }
    } catch (err) {
      showNotification(dispatch, 'Не удалось отменить', 'error');
    }
  };

  const cardMod = getCardMod();

  return (
    <motion.div
      initial={{ opacity: 0, y: -16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.12 }}
      style={{ width: '100%' }}
    >
      <div className={`sub-card-arch ${cardMod}`}>
        <div className="sub-card-body-arch">
          <div className="sub-card-row">
            <span className="sub-card-date">С {format_data(currentNote.date_from)}</span>
            <span className="sub-card-date">По {format_data(currentNote.date_until)}</span>

            <div className="sub-card-actions" ref={actionsRef}>
              {(currentNote.approved || currentNote.approved === null) && (
                <>
                  <button
                    className="sub-dots-btn"
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                  >
                    ⋮
                  </button>
                  {dropdownOpen && (
                    <div className="sub-dropdown">
                      <button
                        className="sub-dropdown-item"
                        onClick={(e) => {
                          setDropdownOpen(false);
                          handleSubmit(e);
                        }}
                      >
                        Отменить
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          <div className="sub-card-user">
            <strong>Замещение на:</strong> {currentNote.substitution_user_username}
          </div>

          <div className={`sub-card-status ${
            currentNote.approved
              ? 'sub-card-status--success'
              : currentNote.approved == null
                ? 'sub-card-status--pending'
                : 'sub-card-status--danger'
          }`}>
            {currentNote.approved ? (
              <><AiOutlineCheck /> Активно</>
            ) : currentNote.approved == null ? (
              <><AiFillClockCircle /> В процессе</>
            ) : (
              <><AiOutlineClose /> Не активно</>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
}